import axios from './axios.service'
import authHeader from './auth-header'

const token = authHeader()

class UserService {
  async getAll (queryData) {
    try {
      const response = await axios.get(
        `${process.env.VUE_APP_API_URL}/user/all`,
        { headers: token, params: { ...queryData } }
      )
      return response.data
    } catch (error) {
      return error
    }
  }

  async getUserInformation (id) {
    try {
      const response = await axios({
        method: 'get',
        url: `${process.env.VUE_APP_API_URL}/user/${id}`,
        headers: { Authorization: token.Authorization }
      })
      return response.data
    } catch (error) {
      console.log(error)
    }
  }

  async updateStatus (rowClicked, status) {
    try {
      const response = await axios({
        method: 'put',
        url: `${process.env.VUE_APP_API_URL}/user/update/status/${rowClicked.id}`,
        headers: { Authorization: token.Authorization },
        data: {
          status
        }
      })
      return response
    } catch (error) {
      return error
    }
  }

  async deleteUser (rowClicked) {
    try {
      const response = await axios.delete(
        `${process.env.VUE_APP_API_URL}/user/${rowClicked.id}`,
        { headers: token }
      )
      return response
    } catch (error) {
      return error
    }
  }

  async sendWelcomeEmail (email) {
    try {
      const response = await axios({
        method: 'post',
        url: `${process.env.VUE_APP_API_URL}/sendwelcome`,
        headers: { Authorization: token.Authorization },
        data: {
          email
        }
      })
      return response.data
    } catch (error) {
      return error.response
    }
  }

  async getFormOptions () {
    try {
      const response = await axios({
        method: 'get',
        url: `${process.env.VUE_APP_API_URL}/user/create`,
        headers: { Authorization: token.Authorization }
      })
      return response.data
    } catch (error) {
      console.log(error)
    }
  }

  async storeUser (data) {
    try {
      const response = await axios({
        method: 'post',
        url: `${process.env.VUE_APP_API_URL}/user/signin`,
        headers: { Authorization: token.Authorization },
        data: {
          ...data
        }
      })
      return response
    } catch (error) {
      return error
    }
  }

  async updateUser (id, data) {
    try {
      const response = await axios({
        method: 'put',
        url: `${process.env.VUE_APP_API_URL}/user/update/${id}`,
        headers: { Authorization: token.Authorization },
        data: {
          ...data
        }
      })
      return response
    } catch (error) {
      return error.response
    }
  }
}

export default new UserService()
